/// <reference path="../include.ts" />

namespace project_guide {

	import View = alm.view.View;
	import Drawer = alm.drawer.Drawer;
	import DrawerTransition = alm.drawer.DrawerTransition;
	import Lang = project_common.Lang;
	import Region = project_common.Region;
	import Area = project_common.Area;
	import Spot = project_common.Spot;
	import Dom = alm.util.Dom;
	import DataParser = project_common.DataParser;
	import LangUtil = project_common.LangUtil;
	import Application = project_common.Application;
	import DomUtil = project_common.DomUtil;
	import GuideLocalizable = project_guide.GuideLocalizable;

	export class DrawerContent extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super(jQuery('#drawer-content'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.drawer = new Drawer(view, DrawerTransition.right);
			this.languageSelector = new LanguageSelector(view.find('.language-selector'));
			this.openButton = jQuery('#drawer-open-button');

			// reset
			this.clearContext();

			return view;
		}

		protected implReady():void {
			this.languageSelector.ready();
			this.setupLang();
		}

		protected implFinalize():void {
			this.languageSelector.finalize();
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.languageSelector.show(useTransition);
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.languageSelector.hide(useTransition);
			});
		}





		public clearContext():void {
			const view = this.getView();

			// drawer content
			const itemContainer = view.find('.region-container');
			itemContainer.empty();

			// language selector
			this.languageSelector.clearContext();
		}

		public setContext():void {
			this.clearContext();
			const lang = Application.getPresetContext().lang;
			const spot = Application.getSpotData();

			// drawer content
			{
				const view = this.getView();
				const itemContainer = view.find('.region-container');
				const itemDataList = spot.regions;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const itemData = itemDataList[i];
					const itemView = this.createRegionView(spot, itemData, lang);
					itemContainer.append(itemView);
				}
			}

			// open button
			this.openButton.find('a').text(DataParser.localize(GuideLocalizable.drawerOpenButtonLabel, lang));

			// language selector
			this.languageSelector.setContext();
		}

		private createRegionView(spot:Spot, region:Region, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('drawer-item-region-template'));

			// name
			{
				const nameField = view.find('.region-name .text');
				DomUtil.setHtml(nameField, DataParser.localize(region.name, lang));
			}

			const itemContainer = view.find('.area-container');
			const itemDataList = region.areas;
			const itemCount = itemDataList.length;
			for (let i = 0; i < itemCount; ++i) {
				const itemData = itemDataList[i];
				const itemView = this.createAreaView(spot, region, itemData, lang);
				itemContainer.append(itemView);
			}

			return view;
		}

		private createAreaView(spot:Spot, region:Region, area:Area, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('drawer-item-area-template'));

			const nameField = view.find('.area-name');

			// setup click action
			//nameField.attr('href', '#/' + region.urn + '/' + area.urn);
			nameField.on('click', (event:JQuery.ClickEvent):void => {
				this.drawer.close();

				//window.location.href = '#/' + region.urn + '/' + area.urn + '/' + zone.urn + '/' + species.urn;
				this.dispatchEvent(new DrawerContentEvent(DrawerContentEvent.requireGotoScene, this, region, area));
			});

			// name
			{
				DomUtil.setHtml(nameField, DataParser.localize(area.name, lang));
			}

			return view;
		}





		private setupLang():void {
			this.getView().find('.lang-container .lang-item').each((index:number, element:HTMLElement) => {
				const target = jQuery(element);
				const lang = <Lang>target.attr('data-lang');
				this.setupLangButton(target, lang);
			});
		}

		private setupLangButton(target:JQuery, lang:Lang):void {
			target.on('click', (event:JQuery.ClickEvent):void => {
				LangUtil.saveLanguage(lang, true);
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public static getInstance():DrawerContent { return this.instance || (this.instance = new DrawerContent()) };
		private static instance:DrawerContent = null;

		private drawer:Drawer;
		private openButton:JQuery;
		private languageSelector:LanguageSelector;
	}
}
